import React, { useEffect } from 'react'
import { Typography, Button } from 'antd'
import { PlusOutlined } from '@ant-design/icons'
import { connect } from 'react-redux'

import UserAttributeModal from './Modal2'
import Segmentation from 'Components/Segmentation'
import './index.scss'
const { Title } = Typography

interface Props {
  onAddNewNode: (subType: string, values: any) => void
  onUpdateNode: (values: any) => void
  value: any
  segmentation: any
  isPopoverVisible: boolean
  resetSegmentation: any
  fetchDimensions: any
  setSegmentationState: any
  dimensions: any
  CJTree?: any // CJTree từ Redux store
  toggleDimensionModal?: any // For opening the modal
  setCurrentGroup?: any // For setting current group
}

const UserAttribute: React.FC<Props> = ({
  onAddNewNode,
  onUpdateNode,
  value,
  segmentation,
  isPopoverVisible,
  resetSegmentation,
  fetchDimensions,
  setSegmentationState,
  dimensions,
  CJTree,
  toggleDimensionModal,
  setCurrentGroup,
}) => {
  const onSubmit = (values: any) => {
    onAddNewNode && onAddNewNode('checkUserAttr', values)
    onUpdateNode && onUpdateNode(values)
  }

  const handleFetchSegments = async () => {
    setSegmentationState({ key: 'isFetching', value: true })
    await resetSegmentation()
    
    // Tìm entrance channel từ CJTree
    let entranceChannel = null
    try {      
      // Hàm đệ quy tìm entrance node trong CJTree
      const findEntranceNode = (node: any): any => {
        if (node?.nodeType === 'entrance' || node?.parentType === 'entrance') {
          return node
        }
        if (node?.childrenNodes) {
          for (const child of node.childrenNodes) {
            const found = findEntranceNode(child)
            if (found) return found
          }
        }
        return null
      }
      
      const entranceNode = findEntranceNode(CJTree)
      entranceChannel = entranceNode?.value?.channel
    } catch (error) {
      console.error('Error finding entrance channel:', error)
    }
    
    // Fetch dimensions với entrance channel
    await fetchDimensions({ 
      type: 'check_user_attr',
      entranceChannel: entranceChannel 
    })
    
    value && setSegmentationState({ key: 'data', value: [value] })
    setSegmentationState({ key: 'isFetching', value: false })
  }

  useEffect(() => {
    if (isPopoverVisible) {
      handleFetchSegments()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPopoverVisible])

  return (
    <div className="UserAttributeComponent">
      <div className="form-item">
        <Title className="field-title">Attribute(s):</Title>

        <Segmentation
          dimensions={dimensions}
          isVisible={isPopoverVisible}
          dimensionModal={UserAttributeModal}
          segmentation={segmentation}
        ></Segmentation>
      </div>
      <div
        className="form-item"
        style={{ display: 'flex', justifyContent: 'space-between', margin: 0, marginTop: 15 }}
      >
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => {
            setCurrentGroup && setCurrentGroup({ index: 0 })
            setSegmentationState({ key: 'editingSegment', value: null })
            toggleDimensionModal && toggleDimensionModal()
          }}
        >
          Add
        </Button>
        <Button onClick={() => onSubmit(segmentation[0])} type="primary">
          Save
        </Button>
      </div>
    </div>
  )
}

interface StateProps {
  segmentation: any
  customerJourney: any
}

export default connect(
  (state: StateProps) => ({
    segmentation: state.segmentation.data,
    visible: state.segmentation.dimensionModalVisible,
    dimensions: state.segmentation.dimensions,
    CJTree: state.customerJourney?.CJTree,
  }),
  (dispatch: any) => ({
    toggleDimensionModal: dispatch.segmentation.toggleDimensionModal,
    fetchDimensions: dispatch.segmentation.fetchDimensions,
    setSegmentationState: dispatch.segmentation.setState,
    resetSegmentation: dispatch.segmentation.resetState,
    setCurrentGroup: dispatch.segmentation.setCurrentGroup,
  })
)(UserAttribute)
